var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    fill: "#E7E7E7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,30 L5,30 C3.346,30 2,28.654 2,27 L2,12.167 L30,12.167 L30,27 C30,28.654 28.654,30 27,30 L27,30 Z M5,5 L6,5 C6,6.654 7.346,8 9,8 C10.654,8 12,6.654 12,5 L20,5 C20,6.654 21.346,8 23,8 C24.654,8 26,6.654 26,5 L27,5 C28.654,5 30,6.346 30,8 L30,10.167 L2,10.167 L2,8 C2,6.346 3.346,5 5,5 L5,5 Z M8,3 C8,2.448 8.448,2 9,2 C9.552,2 10,2.448 10,3 L10,5 C10,5.552 9.552,6 9,6 C8.448,6 8,5.552 8,5 L8,3 Z M22,3 C22,2.448 22.448,2 23,2 C23.552,2 24,2.448 24,3 L24,5 C24,5.552 23.552,6 23,6 C22.448,6 22,5.552 22,5 L22,3 Z M27,3 L26,3 C26,1.346 24.654,0 23,0 C21.346,0 20,1.346 20,3 L12,3 C12,1.346 10.654,0 9,0 C7.346,0 6,1.346 6,3 L5,3 C2.243,3 0,5.243 0,8 L0,27 C0,29.757 2.243,32 5,32 L27,32 C29.757,32 32,29.757 32,27 L32,8 C32,5.243 29.757,3 27,3 L27,3 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16 C7.896,16 7,16.896 7,18 C7,19.104 7.896,20 9,20 C10.104,20 11,19.104 11,18 C11,16.896 10.104,16 9,16",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,16 C14.896,16 14,16.896 14,18 C14,19.104 14.896,20 16,20 C17.104,20 18,19.104 18,18 C18,16.896 17.104,16 16,16",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,16 C21.896,16 21,16.896 21,18 C21,19.104 21.896,20 23,20 C24.104,20 25,19.104 25,18 C25,16.896 24.104,16 23,16",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22 C7.896,22 7,22.896 7,24 C7,25.104 7.896,26 9,26 C10.104,26 11,25.104 11,24 C11,22.896 10.104,22 9,22",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,22 C14.896,22 14,22.896 14,24 C14,25.104 14.896,26 16,26 C17.104,26 18,25.104 18,24 C18,22.896 17.104,22 16,22",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,22 C21.896,22 21,22.896 21,24 C21,25.104 21.896,26 23,26 C24.104,26 25,25.104 25,24 C25,22.896 24.104,22 23,22",
    id: "Fill-11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.329b9e8ff97a068edea55236721a2d90.svg";
export { ForwardRef as ReactComponent };